import React, {useContext, useEffect, useState} from "react";
import { Button, Card, Col, ListGroup, Row} from "react-bootstrap";
import { useParams} from "react-router-dom";
import {accountContext} from "../../App";
import AuthCheck from "../../components/AuthCheck";
import axios from "axios";
import CaseDetails from "../components/CaseDetails";


export default function StudentMain() {
    // let navigate = useNavigate();


    let { studentnumber } = useParams();
    useContext(accountContext);

    const [cases,setCases] = useState({});

    const [selectedCase, selectCase] = useState(null);


    useEffect(()=>{
        axios.get("/api/student/"+studentnumber+"/cases",{
            withCredentials: false} )
            .then(response => {
                setCases(response.data)
                for (const mod of Object.values(response.data)) {
                    if(mod[0] && mod[0].id)
                        selectCaseFunction(mod[0].id);
                }
            })
            .catch(err => {
                console.error(err)
            });
    }, [studentnumber]);


    function selectCaseFunction(id){
        selectCase(id);
    }

    const handleEnrollButtonClick = () => {
        const input = window.prompt('Enter the module code to enroll in:');
        if(input){
            //verify input code fits format DDD-NNNNNN where D is a digit and N is a letter
            const regex = new RegExp("^[0-9]{3}-[0-9a-zA-Z]{6}$");
            if(regex.test(input)){
                axios.post("/api/student/"+studentnumber+"/enroll", new URLSearchParams({
                    code: input
                }))
                    .then(response => {
                        setCases(response.data);
                    })
                    .catch(err => {
                        console.error(err);
                    });//005-0fefca
            }else{
                alert("Invalid module code format. Please enter a valid module code.");
                handleEnrollButtonClick();
            }
        }
    };

    return(
        <>
            <AuthCheck/>
            <Row style={{position:"relative",width:"100%",  paddingTop: "20px",height: "calc(100% - 20px)"}}>
                <Col xs={{span: 12}} md={{span: 6}} lg={{span: 4}} className="mb-3 h-100">
                    <Card className="h-100">
                        <Card.Body style={{overflowY:"scroll"}}>
                            <h4>Select module</h4>


                            {Object.entries(cases).map(([key,list]) =>
                                <Card key={key}>
                                    <Card.Header>{key}</Card.Header>
                                    <Card.Body>
                                        <ListGroup >
                                            {list.map((object) =>
                                                <ListGroup.Item
                                                    key={"object_"+object.id}
                                                action
                                                onClick={()=>selectCaseFunction(object.id)}
                                                className="d-flex justify-content-between align-items-start"
                                            >
                                                <div className="ms-2 me-auto">
                                                    <div className="fw-bold">{object.name}</div>
                                                    {new Date(object.deadline).toLocaleString()}
                                                </div>

                                            </ListGroup.Item>)}
                                        </ListGroup>
                                    </Card.Body>
                                </Card>
                            )}
                            <div className="flex justify-center mt-3">
                                <Button onClick={handleEnrollButtonClick} className="w-100">Enroll new module</Button>
                            </div>

                        </Card.Body>
                    </Card>
                </Col>
                <Col xs={{span: 12}} md={{span: 6}} lg={{span: 8}} className="mb-3 h-100">
                    <Card className="h-100">
                        <Card.Body>
                            {selectedCase ? <CaseDetails id={selectedCase}/> :  <h3>Loading...</h3>}
                        </Card.Body>
                    </Card>
                </Col>
            </Row>


        </>
    )
}
